'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bpfrpt_proptype_ItemProps = undefined;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var bpfrpt_proptype_ItemProps = {
  tag: _propTypes2.default.any,
  itemRef: _propTypes2.default.func,
  active: _propTypes2.default.bool,
  label: function label() {
    return (typeof _react.bpfrpt_proptype_Node === 'function' ? _react.bpfrpt_proptype_Node.isRequired ? _react.bpfrpt_proptype_Node.isRequired : _react.bpfrpt_proptype_Node : _propTypes2.default.shape(_react.bpfrpt_proptype_Node).isRequired).apply(this, arguments);
  },
  value: _propTypes2.default.any,
  extraLabel: function extraLabel() {
    return (typeof _react.bpfrpt_proptype_Node === 'function' ? _react.bpfrpt_proptype_Node : _propTypes2.default.shape(_react.bpfrpt_proptype_Node)).apply(this, arguments);
  },
  description: function description() {
    return (typeof _react.bpfrpt_proptype_Node === 'function' ? _react.bpfrpt_proptype_Node : _propTypes2.default.shape(_react.bpfrpt_proptype_Node)).apply(this, arguments);
  },
  appearance: _propTypes2.default.oneOf(['row', 'head']),
  icon: _propTypes2.default.string,
  iconAlign: _propTypes2.default.oneOf(['left', 'right']),
  customIcon: _propTypes2.default.any,
  color: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  extraLabelClass: _propTypes2.default.string,
  className: _propTypes2.default.string
};
exports.bpfrpt_proptype_ItemProps = bpfrpt_proptype_ItemProps;